import { M_Select } from "../../../../M_Components";
import { useTranslation } from "react-i18next";

export const BooleanForm = ({ propertyChangeCallback, field, errors, canEdit }) => {
    const [t, i18n] = useTranslation();

    const handleChange = (property, value) => {
        propertyChangeCallback(property, value);
    }

    const dropdownOptions = [true, false];

    return (
        <>
            <M_Select
                label={t("NgeDefaultValue")}
                value={field.defaultValue ?? ""}
                options={dropdownOptions.map(el => ({
                    label: `${el}`,
                    value: `${el}`
                })
                )}
                disabled={!canEdit}
                onChange={(e) => handleChange("defaultValue", e.target.value)}
            />
        </>
    )
}
